import React from 'react';
import useTools from '../../Hooks/useTools';
import Tool from './Tools/Tool';

const AllProduct = () => {
    const [tools] = useTools();

    const recentTools = [...tools].reverse()

    return (
        <div>
            <div className='tools-bg pt-28 py-10 md:relative md:z-0'>
                <h1 className='text-center text-5xl font-semibold text-white my-5'>Lenses We have</h1>
                <p className='text-center text-2xl text-slate-100 mb-16'>Tools that you need most for make your life easy</p>
                <div className="hero">
                    <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4'>
                        {
                            recentTools.map(tool => <Tool
                                key={tool._id}
                                tool={tool}
                            >
                            </Tool>)
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AllProduct;